// utils.js
export const getStatusDot = (status) => {
  let dotColor;
  switch (status) {
    case "Pending":
      dotColor = "orange";
      break;
    case "Not Approved":
      dotColor = "red";
      break;
    case "On Hold":
      dotColor = "gray";
      break;
    case "Approved":
      dotColor = "green";
      break;
    default:
      dotColor = "gray";
  }

  return (
    <span className="d-flex align-items-center">
      <span
        style={{
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor: dotColor,
          marginRight: "8px",
        }}
      ></span>
      {status}
    </span>
  );
};

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
};
  